import * as React from "react";

import { type Action } from "./actions";
import {
  type ImagePanelConfig,
  LegendPosition,
  type PlotPanelConfig,
  type State,
  TimeBoundsSource,
} from "./schema";

export const INITIAL_STATE: State = {
  version: "visualization_v1",
  files: [],
  datasources: [],
  panels: {},
  layout: {
    id: "root",
    axis: "x",
    relativeSize: 1,
    children: [],
  },
};

export const DEFAULT_IMAGE_PANEL_CONFIG: ImagePanelConfig = {
  rotation: 0,
  stretchToFitCanvas: true,
};

// `satisfies` rather than a `: PlotPanelConfig` annotation: every field of
// PlotPanelConfig is optional, and consumers read these values as the right-hand
// side of `state.config?.x ?? DEFAULT_PLOT_PANEL_CONFIG.x`, where the fallback
// has to be defined.
export const DEFAULT_PLOT_PANEL_CONFIG = {
  timeBoundsSource: TimeBoundsSource.FilesInWorkspace,
  showEvents: true,
  showPlayhead: true,
  legendPosition: LegendPosition.TopLeft,
} satisfies PlotPanelConfig;

export type Dispatch = React.Dispatch<Action<unknown>>;
const INITIAL_DISPATCH: Dispatch = () => {
  /** noop */
};

export const VizStateContext = React.createContext(INITIAL_STATE);
export const VizStateDispatchContext = React.createContext(INITIAL_DISPATCH);
